/**
 * PillManager (Client) - Lokaler Pill-Cache (fieldId -> Pill-Info)
 * Ersetzt die rohe Map-Verwendung im MultiplayerClient, Verhalten identisch.
 * @copyright reDim GmbH | @link https://www.redim.de | @contact team@redim.de
 */
export class PillManager {
    constructor() {
        /** @type {Map<*, *>} fieldId -> Pill-Info */
        this._pills = new Map();
    }

    /**
     * Pille für ein Feld setzen/überschreiben
     * @param {*} fieldId
     * @param {*} pill
     */
    addPill(fieldId, pill) {
        this._pills.set(fieldId, pill);
    }

    /**
     * Pille eines Feldes entfernen
     * @param {*} fieldId
     * @returns {boolean} - true wenn vorhanden und entfernt
     */
    removePill(fieldId) {
        return this._pills.delete(fieldId);
    }

    /**
     * Pille eines Feldes holen
     * @param {*} fieldId
     * @returns {*|undefined}
     */
    getPill(fieldId) {
        return this._pills.get(fieldId);
    }

    /**
     * Alle Pillen löschen
     */
    clear() {
        this._pills.clear();
    }

    /**
     * Iterierbare [fieldId, pill]-Einträge
     * @returns {IterableIterator<[*, *]>}
     */
    entries() {
        return this._pills.entries();
    }

    /**
     * Anzahl gespeicherter Pillen
     * @returns {number}
     */
    get size() {
        return this._pills.size;
    }
}

export default PillManager;
